module.exports = __webpack_public_path__ + "static/img/322.076de4d3.jpeg";